import React from "react";
import Search from "@material-ui/icons/Search";
import { makeStyles, IconButton, Paper, InputBase } from "@material-ui/core";

export const SearchField = ({ label, value, onChange, onSubmit, color }) => {
  const classes = useStyles();

  const handleEnterClick = (e) => {
    if (e.key === "Enter") {
      onSubmit(e);
      onChange("");
    }
  };

  return (
    <Paper
      component="form"
      className={color ? classes.rootGray : classes.root}
      elevation={0}
    >
      <InputBase
        className={classes.input}
        placeholder={label}
        inputProps={{ "aria-label": label }}
        onChange={(event) => onChange(event.target.value)}
        value={value}
        onKeyPress={handleEnterClick}
      />
      <IconButton aria-label="search" onClick={onSubmit} size="small">
        <Search />
      </IconButton>
    </Paper>
  );
};

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  root: {
    padding: "0px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "36px",
  },
  rootGray: {
    padding: "0px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "36px",
    backgroundColor: "#efefef",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
}));
